import moment from 'moment';

/**
 * Get state of toggle All Day to track hour filter.
 * if the endDate is end of day then it is All Day, return ON.
 * if the endDate is not end of day then it is not All Day, return OFF.
 *
 * @param {string} endDate end of date.
 * @returns {string}
 */

export function getToggleAllDayState(endDate) {
  const TIME_FORMAT = 'HH:mm:ss';
  const END_OF_DAY = '23:59:59';
  if (moment(endDate).format(TIME_FORMAT) === END_OF_DAY) {
    return 'ON';
  }
  return 'OFF';
}
